export default __webpack_public_path__ + "static/media/HDTX_KI Go Private 2025.b29712df.pdf";